export default "__VITE_ASSET__ea9cd14d__"